import React, {Component} from 'react';
import _ from 'lodash';
import Search from './Search';
import { actions as meActions } from 'modules/me';
import { Row, Col, Icon, Tooltip, Badge ,message } from 'antd';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import { routeActions } from 'react-router-redux';
import { logAsync } from 'helpers/elogAsync';

import clientId from 'clientId';
const umacLogoUrl = require('./images/spop-umac-logo.png');
const ersLogoUrl = require('./images/ers-logo.png');
const umaxLogoUrl = require('./images/umax-logo.png');

const container = connect(
  (state) => ({
    clipping: _.get(state, 'collection.globalIds'),
    permission: _.get(state, 'me.permission'),
  })
);

class AffixSearch extends Component {
  render() {
    const {clipping, dispatch, permission} = this.props;
    let logoUrl = ersLogoUrl;
    switch(clientId) {
      case "spop": 
        if (window.location.host.split('.')[0] == "spop-umac") {
          logoUrl = umacLogoUrl;
        } else {
          logoUrl = ersLogoUrl;
        }
        break;
      case "hkspop": 
        logoUrl = umaxLogoUrl;
        break;
    }
    return(
      <div>
        <div className='affix-search pull-left'>
          <img className="logo" src={logoUrl} />
          <div style={{display: "inline-block"}}>
            <Search afif={true}/>
          </div>
        </div>
        <div className="pull-right margin-right-lg" style={{lineHeight: '60px'}}>
          <div className="pull-right margin-left-lg" >
            <a
              style={{display: "inline-block"}}
              onClick={() => {
                const {register_email} = localStorage;
                logAsync({
                  type: "sPOP-quit",
                  data: {
                    url: window.location.href,
                    user: register_email
                  }
                })
                localStorage.clear();
                location.replace('/login.html');
              }}>
              <Tooltip placement="bottom" title={t('commonQuit')}>
                <i className="mediaType-icon logout-icon"></i>
              </Tooltip>
            </a>
          </div>
          <div className="pull-right margin-left-lg" >
            <Tooltip placement="bottom" title="收藏夾">
              <Badge
                onClick={() => {
                  dispatch(routeActions.push({pathname: '/collection'}))
                  .then(() => {
                    const {register_email} = localStorage;
                    logAsync({
                      type: "sPOP-click-collection",
                      data: {
                        url: window.location.href,
                        user: register_email,
                      }
                    })
                  })
                }}
                className="cursor-pointer"
                count={clipping.length}
                overflowCount={99}
              >
                <a><i className="mediaType-icon collection-icon"></i></a>
              </Badge>
            </Tooltip>
          </div>
          {false &&
            <div className="pull-right margin-left-lg" >
              <Tooltip placement="bottom" title="個人中心">
                <a
                  style={{display: "inline-block"}}
                  onClick={() => {
                    if (_.get(permission, 'favoriteQuota.enabled')) {
                      dispatch(routeActions.push({pathname: '/me'}))
                      .then(() => {
                        const {register_email} = localStorage;
                        logAsync({
                          type: "sPOP-click-me",
                          data: {
                            url: window.location.href,
                            user: register_email
                          }
                        })
                      })
                    } else {
                      dispatch(routeActions.push({pathname: '/login'}))
                    }
                  }}>
                  <i className="mediaType-icon person-icon"></i>
                </a>
              </Tooltip>
            </div>
          }
        </div>
      </div>
    )
  }
}
export default container(AffixSearch)



/** WEBPACK FOOTER **
 ** ./src/app/modules/header/components/AffixSearch.js
 **/